import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 80vh;
  flex-direction: column;
  font-size: 0.9rem;
  ${({ loading }) =>
    loading &&
    css`
      opacity: 0.9;
      pointer-events: none;
    `}
`;
export const AddContact = styled.div`
  display: flex;
  width: 100%;
  height: 4.5rem;
  flex-direction: row;
  align-items: center;
  padding: 0.5em;
  margin-top: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background-color: #e8e8e8;
  }
  > span {
    display: flex;
    height: 3.5rem;
    width: 3.5rem;
    margin-left: 5px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #1d86ff;
    color: #ffffff;
  }
  > div {
    margin-left: 0.75rem;
    font-size: 1rem;
    font-weight: 500;
    color: #495057;
  }
`;
export const Content = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  min-width: 300px;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  .add-- {
    display: flex;
    width: 100%;
    justify-content: right;
    label {
      display: flex;
      align-items: center;
      gap: 0.2rem;
      margin-bottom: 0.5rem;
      cursor: pointer;
    }
  }
  .search {
    padding: 0;
    height: 2.5rem;
  }
  .back-- {
    display: flex;
    align-items: center;
    width: 6rem;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .icon-- {
    font-size: 2rem;
  }
  .card--Contact {
    display: flex;
    height: 4.5rem;
    flex-direction: row;
    list-style-type: none;
    padding: 0.5em;
    cursor: pointer;
    border-radius: 6px;

    &:hover {
      background-color: #e8e8e8;
    }

    .avatar-- {
      display: flex;
      width: 4rem;
      height: 3.65rem;
      justify-content: center;
      align-items: center;
    }

    .info-- {
      display: flex;
      width: calc(100% - 4rem);
      max-width: calc(100% - 4rem);
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      .name {
        display: flex;
        width: 100%;
        height: 50%;
        font-size: 1.2rem;
        font-weight: 500;
        color: black;
        .name--overflow {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .description {
        display: flex;
        width: 100%;
        height: 50%;
        font-size: 1rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #eee;
      }
    }
  }
`;
export const Contacts = styled.ul`
  display: flex;
  width: 30rem;
  height: 100%;
  margin-top: 4px;
  flex-direction: column;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgb(0, 0, 0, 0.2);
  }
  ${({ selected }) =>
    selected &&
    css`
      opacity: 0.6;
      pointer-events: none;
    `}
`;
export const SelectMessage = styled.div`
  display: flex;
  flex-direction: column;
  width: 40rem;
  height: 100%;
  gap: 1rem;

  .message-- {
    flex: 1;
    height: auto;
    max-height: calc(100%);
    overflow: hidden;
  }

  .list--message {
    flex: 1;
    display: flex;
    width: 100%;
    overflow: hidden;
  }

  .custom-message {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 0.5rem;
    textarea {
      width: 100%;
      min-height: 5rem;
      padding: 0.75rem;
      border-radius: 6px;
      border: 1px solid #dadce0;
      resize: vertical;
      font-family: Montserrat, Sans-serif;
      font-size: 1rem;
      background-color: #f8f8f8;
      &:focus {
        outline: none;
        border-color: #1d86ff;
      }
    }
  }
`;

export const Revision = styled.div`
  display: flex;
  width: 35rem;
  height: 100%;
  flex-direction: column;
  gap: 1rem;
  .to-- {
    margin-left: 0.5rem;
    font-size: 1rem;
  }
  > .contact-- {
    border-radius: 6px;
    background-color: #f5f5f5;
    box-shadow: 0px 5px 10px -2px rgba(0,0,0,0.05);
    background: #f5f5f5;
    border: 1px solid #dadce0;
  }
  .contact--selected {
    pointer-events: none;
    border-radius: 6px;
  }
  .message--selected {
    display: flex;
    width: 100%;
    min-height: 3rem;
    padding: 1rem;
    overflow-y: auto;
    border-radius: 6px;
    box-shadow: 0px 5px 10px -2px rgba(0,0,0,0.05);
    background: #f5f5f5;
    border: 1px solid #dadce0;
    > p {
      letter-spacing: 0.4px;
      line-height: 18px;
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgb(0, 0, 0, 0.2);
    }
  }
`;
export const Next = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  justify-content: center;
  align-items: center;
  button {
    display: flex;
    cursor: pointer;
    outline: none;
    border: none;
    width: 30%;
    height: 2.5rem;
    border-radius: 4px;
    color: #ffffff;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    background-color: #0ba997;
    transition: all 140ms ease-in-out;

    ${({ loading }) =>
      loading &&
      css`
        width: 3rem;
      `}
  }
`;
export const Send = styled.div`

  display: flex;
  width: 100%;
  flex: 1;
  justify-content: center;
 
  button {
    display: flex;
    cursor: pointer;
    outline: none;
    border: none;
    height: 3rem;
    width: 100%;
    border-radius: 4px;
    color: #ffffff;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    background-color: #1d86ff;
    transition: all 140ms ease-in-out;

    ${({ loading }) =>
      loading &&
      css`
        width: 3rem;
      `}
  }
`;
